<template>
  <v-form>
    <v-btn block @click="onScan" class="top60" x-large>
      <v-icon dark>mdi-credit-card-scan</v-icon>
      Сканировать УПД
    </v-btn>

    <v-btn block @click="onSearch" class="top20" x-large>
      <v-icon dark>mdi-magnify</v-icon>
      Поиск по номеру УПД
    </v-btn>
  </v-form>
</template>

<script>
export default {
  methods: {
    onScan() {
      this.$router.push({ name: "UpdScan" });
    },
    onSearch() {
      this.$router.push("/upd/search");
    },
  },
};
</script>
